import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CartItem from 'apps/cart/components/CartItem';
import CartFooter from 'apps/cart/components/CartFooter';
import { formatPriceWithDecimal } from 'common/helpers/priceFormat';
import { t } from 'translates';
import Spinner from 'common/components/Spinner';
import Icon from 'common/components/Icon';
import { getCountProducts } from "../../cart-header/CartHeaderContainer";
import classNames from 'classnames';
import Modal from "../../modal/Modal";
import ModalSessions from "../../modals/ModalSessions/ModalSessions";
import ContentMessage from "../../../common/components/contentMessage";
import EmptyCartItem from "./EmptyCartItem";
import isMobile from "common/helpers/isMobile";
import Slider from "react-slick";
const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

export const getProductToAnalytics = (item) => {
  const analyticsValue = item.data && item.data.analytics ? item.data.analytics : null;
  return {
    item_id: item.product_id !== undefined ? item.product_id : (item.cursusId !== undefined ? item.cursusId : (item.data !== undefined ? item.data.codeId : item.id)),
    item_name: item.product_original_title !== undefined ? item.product_original_title : item.original_title,
    item_category: item.category !== undefined ? item.category : 'Transverse',
    price: Number(item.price) + Number(item.tax),
    item_type: item.category_type !== undefined ? item.category_type : 'package',
    quantity: 1,
    course_participants: item.courseParticipants ? item.courseParticipants : item.persons,
    course_language: item.original_language ? item.original_language : 'N/A',
    course_date: item.original_date ? item.original_date : 'N/A',
    course_time: item.display_time ? item.display_time : 'N/A',
    item_list_name: analyticsValue ? analyticsValue.item_list_name : 'N/A',
    item_list_id: analyticsValue ? analyticsValue.pg_type + ' - ' + analyticsValue.item_list_name + ' - ' + analyticsValue.url : 'N/A',
    index: analyticsValue ? analyticsValue.index : 0,
  };
};

export default class CartComponent extends Component {
  static propTypes = {
    cart: PropTypes.shape({
      currency_symbol: PropTypes.string,
      currency_code: PropTypes.string,
      currency_separator: PropTypes.string,
      tax: PropTypes.number,
      subtotal: PropTypes.number,
      purchases: PropTypes.object,
      isEmpty: PropTypes.bool,
      code: PropTypes.string,
      payment_methods: PropTypes.shape({
        base_path: PropTypes.string,
        types: PropTypes.array,
      }),
      quota: PropTypes.shape({
        quota: PropTypes.number,
        errors: PropTypes.array,
      }),
      discount: PropTypes.object.isRequired,
      hasExpired: PropTypes.bool.isRequired,
      include_tax: PropTypes.bool.isRequired,
      staffUser: PropTypes.bool,
      dialog: PropTypes.shape({
        sessions: PropTypes.object,
        openCartOnLoad: PropTypes.bool,
      }),
    }).isRequired,
    actions: PropTypes.object.isRequired,
    onToggleCartState: PropTypes.func.isRequired,
    modal: PropTypes.object.isRequired,
    availableSessions: PropTypes.object.isRequired,
    itemListName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loadingSpinner: true,
      submitSpinner: false,
      loadingSessionsSpinner: false,
      editModalOpen: false,
      selectedSession: undefined,
      type: "sessions",
      contentPurchases: {},
      deletedItem: {},
    };
    this.toggleSpinner = this.toggleSpinner.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.hideError = this.hideError.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onCloseEditModal = this.onCloseEditModal.bind(this);
    this.onDeleteHandler = this.onDeleteHandler.bind(this);
    this.onSelectPersonHandler = this.onSelectPersonHandler.bind(this);
  }

  componentDidMount() {
    this.props.actions.cart.fetch(this.props.cart.isEmpty)
      .then(() => this.toggleSpinner('loadingSpinner'))
      .catch(() => this.toggleSpinner('loadingSpinner'))
      .then(() => {
        let products = [];

        for (let item in this.props.cart.purchases) {
          item = this.props.cart.purchases[item];

          let product = getProductToAnalytics(item);
          Object.keys(product).forEach(key => product[key] === undefined && delete product[key]);
          products.push(product);
        }

        window.dataLayer && window.dataLayer.push({
          'event': "view_cart",
          'ecommerce': {
            'currency': this.props.cart.currency_code,
            'items': products,
          }
        });
      })
      .then(() => {
        this.setState({
          contentPurchases: this.props.cart.purchases,
        });
      });

    const {error} = storage.get('cart');
    storage.set('cart.error', {})
    if (error && error.message) {
      this.props.actions.modal.show('cart.error', error);
    }
  }

  toggleSpinner(spinnerName) {
    this.setState({
      [spinnerName]: !this.state[spinnerName],
    });
  }

  hideAlert(e) {
    e.preventDefault();
    this.props.actions.cart.hideAlert();
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.props.cart.hasExpired) return;

    this.toggleSpinner('submitSpinner');
    this.props.actions.cart.reservation().catch(() => this.toggleSpinner('submitSpinner'));
    if (this.props.cart.errors.persons) {
      window.dataLayer && window.dataLayer.push({
        event: "checkoutError"
      });
    }

    this.props.actions.cart.fetch()
      .then(() => {
        let products = [];
        for (let item in this.props.cart.purchases) {
          item = this.props.cart.purchases[item];

          let product = getProductToAnalytics(item);
          Object.keys(product).forEach(key => product[key] === undefined && delete product[key]);
          products.push(product);
        }

        window.dataLayer && window.dataLayer.push({
          'event': "begin_checkout",
          'ecommerce': {
            'currency': this.props.cart.currency_code,
            'items': products,
          }
        });
      })
  }

  onEdit(id, sessionId, item, session, subtitle, productTitle) {
    this.toggleSpinner('loadingSessionsSpinner');
    const {
      availableSessions: {
        fetch,
      }
    } = this.props.actions;
    this.setState({
      selectedSession: session ? session.id : sessionId,
      selectedItem: session ? session : item,
      sessionSubtitle: subtitle,
      sessionId,
      productTitle,
      type: item.type,
      }
    );
    fetch(id).then((res) => {
      this.toggleSpinner('loadingSessionsSpinner');
      this.setState({
        editModalOpen: true,
      })
    }).catch((err) => {
      this.toggleSpinner('loadingSessionsSpinner');
      console.log(err)
    });
  }

  onCloseEditModal() {
    this.setState({
      editModalOpen: false,
      contentPurchases: this.props.cart.purchases,
    });
  };

  onSelectPersonHandler() {
    this.setState({
      contentPurchases: this.props.cart.purchases,
    });
  }

  onDeleteHandler(id, title) {
    this.setState({
      productTitle: title,
      contentPurchases: {
        ...this.state.contentPurchases,
        [id]: {
          ...this.state.contentPurchases[id],
          isDeleted: true,
        }
      },
      deletedItem: {
        [id]: {
          deletedTitle: title
        },
      }
    })
    setTimeout(() => {
      this.setState({
        deletedItem: {}
      })
    }, 8000);
  }

  get purchases() {
    const {
      cart: {
        currency_separator,
        currency_symbol,
        currency_decimal_separator,
        currency_position,
        include_tax: includeTax,
        hasExpired,
        subtotal,
        tax,
        discount,
        reservationErrors,
        empty_links: emptyLinks,
        staffUser,
        quota,
      },
      giftModal,
    } = this.props;

    const {
      message: errorMessage,
    } = reservationErrors;

    const { contentPurchases } = this.state;

    const {
      editModalOpen,
      selectedSession,
      selectedItem,
      sessionSubtitle,
      productTitle,
      sessionId,
      deletedItem,
      type,
    } = this.state;
    const deletedItemsKeys = Object.keys(deletedItem);
    const sessionKeys = Object.keys(contentPurchases);
    const productKeysForRender = [];
    sessionKeys.forEach((el) => {
      if (!contentPurchases[el].isDeleted) {
        productKeysForRender.push(el);
      }
    })

    const slideWidth = window.innerWidth - 60;

    const sliderSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      centerMode: true,
      variableWidth: true,
      centerPadding: '40px',
    };
    return (
      !!productKeysForRender.length ?
        <Fragment>
          <div className="cart-new__count">
            {`${productKeysForRender.length} ${t('items', DT_CART)}`}
          </div>
          <h3 className="cart-new__description">
            {t('The number of participants is proposed according to program\'s availability', DT_CART)}
          </h3>
          <button
            className="button button-primary button-block button-lg desktop-hidden"
            onClick={this.onSubmit}
            disabled={!Object.keys(contentPurchases).length || hasExpired || staffUser && quota}
          >
            {t('Book now for', DT_CART)}
            &nbsp;
            {formatPriceWithDecimal(tax + subtotal + (discount.success ? -discount.amount : 0), currency_symbol, currency_separator, currency_decimal_separator, currency_position)}
          </button>
          {errorMessage && (
            <ContentMessage
              message={errorMessage}
            />
          )}
          {sessionKeys.sort((a, b) => contentPurchases[a].weight - contentPurchases[b].weight)
            .map((id, index) => (
              <div className="cart-new-item-wrap" key={id}>
                {!contentPurchases[id].isDeleted && (
                  <CartItem
                    index={index}
                    item={{ ...contentPurchases[id], id }}
                    actions={this.props.actions}
                    separator={currency_separator}
                    currency={this.props.cart.currency_symbol}
                    currencyCode={this.props.cart.currency_code}
                    cart={this.props.cart}
                    onToggleCartState={this.props.onToggleCartState}
                    includeTax={includeTax}
                    staffUser={this.props.cart.staffUser}
                    onEdit={this.onEdit}
                    onDeleteHandler={this.onDeleteHandler}
                    giftModal={giftModal}
                    onSelectPersonHandler={this.onSelectPersonHandler}
                    itemListName={this.props.itemListName}
                  />
                )}
                {deletedItem[id] && (
                  <ContentMessage
                    message={`"${deletedItem[id].deletedTitle}" ${t('has been removed', DT_CART)}.`}
                  />
                )}
              </div>
            ))}
          {editModalOpen && (
            <Modal
              className={"new-session-modal"}
              closePortal={this.onCloseEditModal}
            >
              <ModalSessions
                t={t}
                sessionId={sessionId}
                selectedItem={selectedItem}
                selectedSession={selectedSession}
                onCloseModal={this.onCloseEditModal}
                actions={this.props.actions}
                sessionSubtitle={sessionSubtitle}
                productTitle={productTitle}
                type={type}
                currencyCode={this.props.cart.currency_code}
                itemListName={this.props.itemListName}
              />
            </Modal>
          )}

        </Fragment>
        : (
          <Fragment>
            <h2 className="cart-new__message--empty">
              {t('Your basket is empty', DT_CART)}
            </h2>
            <h3 className="cart-new__description"
                dangerouslySetInnerHTML={{__html: t('empty_cart_description', DT_CART)}}
            />
            {deletedItemsKeys.length > 0 && (
              <Fragment>
                {deletedItem[deletedItemsKeys[0]] && (
                  <ContentMessage
                    message={`"${deletedItem[deletedItemsKeys[0]].deletedTitle}" ${t('has been removed', DT_CART)}.`}
                  />
                )}
              </Fragment>
            )}

            {emptyLinks && emptyLinks.length > 0 && (
              <Fragment>
                <div className="empty-links">
                  {isMobile ? (
                    <Fragment>
                      <div className="empty-links__slider">
                        <Slider {...sliderSettings}>
                          {emptyLinks.map((el, i) => (
                            <div className="empty-links__slide" key={i}>
                              <EmptyCartItem
                                data={el}
                                width={slideWidth}
                              />
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {emptyLinks.map((el, i) => (
                        <div className="empty-links__col"vkey={i}>
                          <EmptyCartItem
                            data={el}
                          />
                        </div>
                      ))}
                    </Fragment>
                  )}

                </div>
              </Fragment>
            )}
          </Fragment>
        )
    );
  }

  hideError(e) {
    e.preventDefault();
    this.props.actions.modal.hide('cart.error');
  }

  render() {
    const {
      cart: {
        errors,
        code,
        subtotal,
        tax,
        currency_separator,
        currency_decimal_separator,
        currency_position,
        currency_symbol,
        payment_methods,
        discount,
        dialog,
        reservationErrors,
      },
      actions: {
        cart: {
          addCode,
          deleteCode,
        },
      },
      modal,
    } = this.props;
    const {
      loadingSpinner,
      loadingSessionsSpinner,
      submitSpinner,
    } = this.state;

    const cartCount = getCountProducts(dialog);

    return loadingSpinner ? (
      <Spinner />
    ) : (
      <Fragment>
        {(({ isOpen, message, hideButton = false, type = 'type-error' }) => isOpen && (
          <div className={'cart__alert ' + type}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            <a
              href="#"
              onClick={this.hideError}
              style={{
                display: hideButton ? 'none' : 'inline-block',
              }}
              className="cart__alert-close"
            >
              <Icon name="close" />
            </a>
          </div>
        ))(modal['cart.error'])}
        {errors.persons && (
          <div className="cart__alert">
            {t('request_was_not_successful', DT_CART)}
            <a
              href="#"
              onClick={this.hideAlert}
              className="cart__alert-close"
            >
              <Icon name="close" />
            </a>
          </div>
        )}
        {(submitSpinner || loadingSessionsSpinner) && (
          <Spinner />
        )}
        <div
          className="cart-container"
        >
          <div className={classNames("cart-new", {
            'cart-new--empty': cartCount === 0
          })}>
            <div className="checkout">
              <div className="checkout__inner">
                <div className="checkout__body">
                  <div className="cart-new__products">
                    { this.purchases }
                  </div>
                </div>

                {cartCount > 0 && (
                  <Fragment>
                    <div className="checkout__footer">
                      <CartFooter
                        subtotal={subtotal}
                        tax={tax}
                        currency_symbol={currency_symbol}
                        currency_separator={currency_separator}
                        currency_decimal_separator={currency_decimal_separator}
                        currency_position={currency_position}
                        payment_methods={payment_methods}
                        code={code}
                        addCode={addCode}
                        deleteCode={deleteCode}
                        discount={discount}
                        cart={this.props.cart}
                        onSubmitHandler={this.onSubmit}
                        reservationErrors={reservationErrors}
                        submitSpinner={submitSpinner}
                      />
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
